module.exports = __webpack_public_path__ + "img/reviews-author-15.4801c9e.jpg";